import { useQuery } from '@tanstack/react-query';
import { getWorldCupReport } from '@/api/reports';

export function useWorldCupReport(reportId: string, baseUrl: string) {
  return useQuery({
    // baseUrl is in the key so Brazil and Spain don't collide in the cache.
    queryKey: ['report', baseUrl, reportId],
    queryFn: () => getWorldCupReport(reportId, baseUrl),
  });
}
